const SAFE_URL_PROTOCOLS: ReadonlySet<string> = new Set(["http:", "https:", "mailto:", "tel:", "file:"]);
const RELATIVE_URL_BASE = "https://relative.invalid/";

export const isSafeHref = (value: string): boolean => {
  if (!value.trim()) return false;
  try {
    return SAFE_URL_PROTOCOLS.has(new URL(value, RELATIVE_URL_BASE).protocol);
  } catch {
    return false;
  }
};
